import { CheckCircleOutlined } from '@ant-design/icons';
import { LoadingOutlined } from '@ant-design/icons';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { states } from '../constants/states.constant';
import { Row } from 'antd';

export const boxStatus = (status, fileName, message) => {
	if (status === states[Enviroment.LANGUAGE]?.uploading) {
		return (
			<Row className="uploading">
				<LoadingOutlined className="iconLoading" />
				<Row className="container">
					<span className="fontBold">Cargando</span>
					<span className="fontBold">{fileName}</span>
				</Row>
			</Row>
		);
	}
	if (status === states[Enviroment.LANGUAGE]?.done) {
		return (
			<Row className="success">
				<CheckCircleOutlined className="iconSuccess" />
				<Row className="container">
					<span className="fontBold">Éxito</span>
					<span className="fontBold">{fileName}</span>
					<span>{message}</span>
				</Row>
			</Row>
		);
	}
	return;
};
